/**
 * REST paths relative to the axios `baseURL` (`${API_URL}/api`).
 * Keep in sync with Nest controllers: CompanyController, ReviewController, AuthController.
 */
export const ApiPath = {
  companies: () => "/companies",
  company: (id: string) => `/companies/${id}`,
  /** Nested resource: reviews for one company. */
  companyReviews: (companyId: string) => `/companies/${companyId}/reviews`,

  reviews: () => "/reviews",
  review: (id: string) => `/reviews/${id}`,

  authGoogle: () => "/auth/google",
  authLogout: () => "/auth/logout",
  authMe: () => "/auth/me",
  /** Current user's reviews (AuthController). */
  authMeReviews: () => "/auth/me/reviews",
} as const;
